export const HOME = "/"
export const LOGIN = "/login"
export const BACKUP = "/backup"
export const SYSTEM_LOGIN = "/system-login"
